<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة الانشطة التطوعية",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة الانشطة التطوعية",
          href: "/activities",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      coordinator: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("activity", ["getCoordinator"]),
  },
  methods: {
    ...mapActions("activity", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.coordinator = this.getCoordinator;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.coordinator.qr_id,
            fullName: this.coordinator.full_name,
            date: this.coordinator.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات المنسق</h5></div>
            <div class="row about-list">
              <h4>{{ coordinator.full_name }}</h4>
              <div class="col-md-12">
                <div class="media">
                  <label>معرف التلجرام :</label>
                  <p>{{ coordinator.telegram_link }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ coordinator.phone }}</p>
                </div>
                <div class="media">
                  <label>اذا كان هناك اكثر من منسق يرجى كتابة معلوماتهم جميعا هنا . :</label>
                  <p>{{ coordinator.note }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات البرنامج او النشاط</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <div class="media">
                  <label> إسم الفريق التطوعي أو المنظمة التي تنظم هذا النشاط  :</label>
                  <p>{{ coordinator.team_info.name }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label> نوع البرنامج او النشاط  :</label>
                  <p>{{ coordinator.team_info.program_type.id == 17 ? coordinator.team_info.another_program_type : coordinator.team_info.program_type.title }}</p>
                </div>
                <div class="media">
                  <label> تاريخ اقامة البرنامج  :</label>
                  <p>{{ coordinator.team_info.date_program }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label> مكان اقامة البرنامج :</label>
                  <p>{{ coordinator.team_info.location_program }}</p>
                </div>
                <div class="media">
                  <label> مدة اقامة البرنامج .</label>
                  <p>{{ coordinator.team_info.duration_program }}</p>
                </div>
              </div>

              <hr class="hr-title" />

              <div class="col-md-6">
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> هل حصلت على موافقة الجهة الرسمية المعنية كموافقة الجامعة او مسؤول المنطقة ؟  </label>
                  </div>
                  <p>{{ coordinator.team_info.acceptance_type.title }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label> ما هو العدد المتوقع للفئة المستهدفة ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_2_number_target }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> ما هي أهداف البرنامج او النشاط ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_1_program_goal}}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt=""> 
                   <label> ما هي الامور التي تحتاجها من الحشد ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_3_needs }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> من هي الشخصيات الرسمية التي ستحضر البرنامج ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_4_characters_attending }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> من هي الشخصيات التي ستُحيي البرنامج ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_5_characters_implement_program }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> ما هي التحديات التي تواجهكم لانجاح البرنامج ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_6_challenges }}</p>
                </div>
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label> عدد اعضاء الفريق القائم على تنفيذ البرنامج ؟ </label>
                  </div>
                  <p>{{ coordinator.team_info.question_7_number_members }}</p>
                </div>

                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                   <label> وصف او شرح البرنامج  :</label>
                   </div>
                  <p>{{ coordinator.team_info.description }}</p>
                </div>
                
                <div class="question-content">
                  <div class="quest">
                   <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label> ملاحظات  :</label>
                  </div>
                  <p>{{ coordinator.team_info.note }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <QrCodeCard
              title="استمارة الأنشطة التطوعية "
              :fullName="this.coordinator.full_name"
              :date="this.coordinator.created_at"
              :Id="this.coordinator.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/activities" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
